import React from 'react'
import Link from 'gatsby-link'

import Liver from '../assets/liver.svg'
import Biohazard from '../assets/biohazard.svg'
import Symptoms from '../assets/patient-vomitting.svg'
import Gene from '../assets/gene.svg'
import Gel from '../assets/gel.svg'
import MedicalCase from '../assets/medical-case.svg'
import Checkboard from '../assets/checkboard.svg'
import Patient from '../assets/patient.svg'
import Umbrella from '../assets/umbrella.svg'
import '../styles/category.scss'

export default function Template({ data }) {
  const articles = data.allMarkdownRemark.edges
  if (articles.length > 0) {
    var categoryImg = null
    const category = articles[0].node.frontmatter.category
    const categoryTitle = articles[0].node.frontmatter.categoryDesc

    switch (category) {
      case 'definition':
        categoryImg = Liver
        break
      case 'risk':
        categoryImg = Biohazard
        break
      case 'symptoms':
        categoryImg = Symptoms
        break
      case 'diagnosis':
        categoryImg = Gene
        break
      case 'treatment':
        categoryImg = Gel
        break
      case 'complications':
        categoryImg = Checkboard
        break
      case 'living-with':
        categoryImg = MedicalCase
        break
      case 'prevention':
        categoryImg = Umbrella
        break
      default:
        break
    }

    return (
      <div className="content-container">
        <div className="category">
          <div className="title-container">
            <img src={categoryImg} alt="" />
            <span className="title">{categoryTitle}</span>
          </div>
          <ul className="articles">
            {articles.map(article => (
              <li key={article.node.id} className="article">
                <Link to={'/article/' + article.node.frontmatter.path}>
                  {article.node.frontmatter.title}
                </Link>
                <span className="source">
                  {article.node.frontmatter.source}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export const categoryQuery = graphql`
  query ArticlesByCategory($category: String!) {
    allMarkdownRemark(
      filter: { frontmatter: { category: { eq: $category } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            path
            title
            category
            categoryDesc
            source
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/category.js